module.exports = __webpack_public_path__ + "static/media/paternal-kinship.24f73d07.svg";